import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "../design-system/Avatar";
import { Card, CardHeader, CardBody } from "@material-tailwind/react";
import { checkUser, getFiles } from "../api";
import { giveErrorMessage } from "../utils/common";
import useUserData, { useSessionStorage } from "../utils/useUserData";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../pages/thoughts/chat/RenderResponse";
import styles from "./ThoughtList.module.css"; // Adjust the path/filename as needed
type Thought = {
  filename: string;
  timestamp: string;
  query: string;
  response: string;
  citations: string[];
};

type ThoughtsHeaderProps = {
  thought: Thought;
};
const ThoughtHeader = ({ thought }: ThoughtsHeaderProps) => {
  const userData = useUserData();
  const getInitials = (name: string | undefined) => {
    return name
      ?.split(" ")
      .map(n => n[0])
      .join("");
  };
  const initials = getInitials(userData?.name);

  return (
    <div className={`${styles["header-layout"]} p-1 items-center`}>
      <div className="max-w-14" title={userData?.name}>
        <Avatar initials={initials} className="mr-2" />
      </div>
      <h2 className="justify-self-center font-title line-clamp-2" title={thought.query}>
        {thought.query}
      </h2>
    </div>
  );
};

export const ThoughtList = () => {
  const [individualThought, setIndividualThought] = useState<Thought[]>([]);

  const [selectedItem, setSelectedItem] = useSessionStorage<string>("selectedThought", "");
  const [error] = useState(false);
  const navigate = useNavigate();
  const [statusCode] = useState<number | undefined>();
  const [checkThoughtsFolderNotExist, setCheckThoughtsFolderNotExist] = useState(false);
  const fetchAndSetThoughts = async () => {
    try {
      const check_user_dir = await checkUser();
      const checkUserDirExist = check_user_dir.data;

      if (!checkUserDirExist.exists) {
        return;
      } else {
        const thoughtAllFiles = await getFiles();
        const files = thoughtAllFiles.data;
        if (files.error) {
          setCheckThoughtsFolderNotExist(true);
          // return;
        } else {
          setIndividualThought(files);
        }
        // files.sort((a: any, b: any) => {
        //   const timestampA = Number(a.slice(0, -4)); // Remove '.txt' and convert to number
        //   const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
        //   return timestampB - timestampA;
        // });

        // let tempIndividualThought: Thought[] = [];
        // for (let i = 0; i < Math.min(files.length, loadNumberOfFiles) && fileIndex < files.length; i++) {
        //   const historyResponse = await getFileChats(files[fileIndex].substring(0, files[fileIndex].lastIndexOf(".")));
        //   if (historyResponse.status !== 200) {
        //     fileIndex++;
        //     continue;
        //   }
        //   const data = historyResponse.data.conversation;

        //   const lastObject = data[0]; //select first query
        //   lastObject["filename"] = files[fileIndex].substring(0, files[fileIndex].lastIndexOf("."));
        //   tempIndividualThought.push(lastObject);
        //   fileIndex++;
        // }
        // setIndividualThought(prevThoughts => [...prevThoughts, ...tempIndividualThought]);
        // if (files.length === fileIndex) {
        //   console.log("setHasMore: ", hasMore);
        //   setHasMore(false);
        //   // return;
        // }
      }
    } catch (error) {
      console.error(`Failed to fetch thought files `, error);
    }
  };

  // const fetchMoreThoughts = useCallback(() => {
  //   if (hasMore) {
  //     fetchAndSetThoughts();
  //   }
  // }, [hasMore]);

  useEffect(() => {
    fetchAndSetThoughts();
  }, []);

  useEffect(() => {
    console.log("individualThought updated:", individualThought);
    const timer = setTimeout(() => {
      const thoughts = individualThought;
      if (selectedItem) {
        const el = document.getElementsByClassName("container-selector")[0];
        if (el) {
          const index = thoughts.findIndex(item => item.filename === selectedItem);
          if (index > -1) {
            const selectedCard = el.children[index];
            selectedCard.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
        sessionStorage.removeItem("selectedThought");
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [individualThought]);

  if (checkThoughtsFolderNotExist) {
    return <div className="h-44 card_text_color">Resource not found.</div>;
  }
  if (error) {
    return giveErrorMessage(statusCode);
  }
  return (
    // <div className="flex-grow pb-8 relative" style={{ height: '1500px', overflow: 'auto' }}>
    // <InfiniteScroll
    //   dataLength={individualThought.length}
    //   next={fetchMoreThoughts}
    //   hasMore={hasMore}
    //   loader={
    //     <div className="p-4">
    //       <MultipleLoadingScreen count={3} />
    //     </div>
    //   }
    //   // scrollableTarget="parent"
    //   scrollThreshold={0.7} // Load when 80% down
    // >
    <div className="container-selector">
      {individualThought.map((item: Thought, index) => {
        item.response = item.response.replace(/\[[^\]]*\]/g, "");
        const openSpecificThoughtClick = (item: any) => {
          setSelectedItem(item.filename);
          navigate(`/interaction/${item.filename}`, {
            state: { from: "individual" }
          });
        };

        return (
          <Card
            onClick={() => openSpecificThoughtClick(item)}
            key={index}
            className="mt-6 hover:cursor-pointer  pb-4 card_bg_color card_text_color "
          >
            <CardHeader className="relative card-header-style ">
              <ThoughtHeader thought={item} />
            </CardHeader>
            <CardBody className="p-2 overflow-hidden max-h-[300px] scroll-style">
              <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                {item.response}
              </ReactMarkdown>
            </CardBody>
          </Card>
        );
      })}
    </div>
    // </InfiniteScroll>
  );
};

export default ThoughtList;
